import { render, staticRenderFns } from "./ConfiguracionDeportistas.vue?vue&type=template&id=a23de034"
import script from "./ConfiguracionDeportistas.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracionDeportistas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports